<div class="modal-header">
  <h4 class="modal-title">Rename SubBrand</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="flex flex-row pb-3">
    <div>
      <div class="flex flex-row space-x-4">
        <div class="dx-field flex">
          <div class="pt-2 pr-2.5 pb-2 pl-0">SubBrand:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="selectedEditSubBrandOldName" [readOnly]="true"></dx-text-box>
          </div>
        </div>
        <div class="dx-field flex">
          <div class="pt-2 pr-1 pb-2 pl-0">Id:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="subBrandId" [readOnly]="true"></dx-text-box>
          </div>
        </div>
      </div>
      <div class="flex flex-row space-x-4">
        <div class="dx-field flex">
          <div class="pt-2 pr-1 pb-2 pl-0">Change To:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="selectedEditSubBrandNewName" valueChangeEvent="keyup" (onValueChanged)="valueChanged($event)">
              <dx-validator>
                <dxi-validation-rule 
                    type="required" 
                    message="Field is required">
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col">
    <h4>Affected SubBrand Relations with Current OLD Brand Name</h4>
    <div class="pb-3">
      <dx-data-grid
        [dataSource]="affectedEditSubBrandNameData" 
        [showBorders]="true" 
        [columnAutoWidth]="true" 
      >
        <dxi-column dataField="SubBrandRelationId" caption="SubBrand Relation Id" [customizeText]="customizeSubBrandId"></dxi-column>
        <dxi-column dataField="CompanyName" caption="Company"></dxi-column>
        <dxi-column dataField="MasterBrandName" caption="Master Brand"></dxi-column>
        <dxi-column dataField="BrandName" caption="Brand"></dxi-column>
        <dxi-column dataField="SubBrandName" caption="SubBrand"></dxi-column>
      </dx-data-grid>
    </div>
    <h4>Other existing SubBrand Relations with intended NEW Brand Name</h4>
    <div>
      <dx-data-grid
        #existingBrandNameGrid
        id="existingBrandNameGrid"
        [dataSource]="existingEditSubBrandNameData" 
        [showBorders]="true" 
        [columnAutoWidth]="true" 
      >
        <dxi-column dataField="BrandRelationId" caption="Brand Relation Id"></dxi-column>
        <dxi-column dataField="CompanyName" caption="Company"></dxi-column>
        <dxi-column dataField="MasterBrandName" caption="Master Brand"></dxi-column>
        <dxi-column dataField="BrandName" caption="Brand"></dxi-column>
        <dxi-column dataField="SubBrandName" caption="SubBrand"></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <dx-button
    icon="check"
    type="success"
    text="Rename"
    (onClick)="rename()"
  >
  </dx-button>
  <dx-button
    icon="close"
    text="Cancel"
    (onClick)="activeModal.dismiss('Cross click')"
  >
  </dx-button>
</div>